import { Component, OnInit, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PartnerService } from '../../../../../services/partner.service';
import { JobcardService } from '../../../../../services/jobcard.service';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-jobcard-review',
  templateUrl: './jobcard-review.component.html',
  styleUrls: ['./jobcard-review.component.scss']
})
export class JobcardReviewComponent implements OnInit {
  @Input() serviceLogID:number;
  @Input() serviceID: number;
  @Input() rating: number;
  @Input() review_TrustpilotUrl : string;
  @Input() review_GoogleReviewsUrl : string;

  feedbackMessage: string = "";
  busy: boolean;

  constructor(
    public modal : NgbActiveModal,
    public jobcardService: JobcardService,
    public partnerService: PartnerService
    ) {

     }

  ngOnInit() {

  }

  openLink(url){
    window.open(url, '_blank');
    this.modal.close(true);
  }

  closeModal() {
    // Close the modal by calling the close() method
    this.modal.close(false);
  }

  saveReview(){
    if(this.feedbackMessage.length <= 0)
    {
      Swal.fire({
        title: 'Required',
        text: 'Please enter a message.',
        icon: 'warning'
      });
      return;
    }    

    this.busy = true;

    var data = {
      ServiceID: this.serviceID,
      Rating: this.rating,
      Feedback: this.feedbackMessage
    }

    this.jobcardService.postServiceRatingAnonymous(this.serviceLogID, data).subscribe(result => {
      this.rating = 0;
      this.feedbackMessage = "";
      this.busy = false;
      this.modal.close(true);
    }, err => {
      alert('error');
      this.busy = false;
    });
  }
}
